export const siteConfig = {
  title: 'Auction Chase',
  description:
    'Experience real-time player auctions with live bidding, team management, and comprehensive tournament organization.',
  /** Without additional '/' on the end */
  url: 'https://www.auctionchase.com',
  company: {
    name: 'Auction Chase',
    // registration: 'DE123456789',
    address: 'Coming Soon',
  },
  social: {
    twitter: 'auction_chase',
    facebook: 'auctionchasesports',
    instagram: 'auction_chase',
    linkedin: 'auction-chase',
  },
  contact: {
    email: 'support@auctionchase.com',
    phone: '+919408746509',
  },
  seo: {
    keywords: [
      // Primary Keywords
      'sports auction platform',
      'live sports auction platform',
      'tournament management system',
      'player auction platform',

      // Sports-Specific Keywords
      'cricket auction platform',
      'football player auction',
      'IPL style auction platform',
      'sports league auction system',

      // Feature-Specific Keywords
      'real-time sports bidding',
      'live auction management',
      'team budget management platform',
      'player draft system',

      // Long-tail Keywords
      'how to organize sports player auction',
      'best platform for cricket team auction',
      'sports tournament management platform',
      'live bidding system for sports teams',

      // Intent-based Keywords
      'create online sports auction',
      'manage sports team auction',
      'organize cricket tournament auction',
      'run football team auction',

      // Location-based Keywords
      'sports auction platform india',
      'cricket auction platform UAE',
      'tournament management system USA',
      'player auction platform UK',

      // Existing High-Performance Keywords
      'live ipl auction',
      'box cricket tournament',
      'turf cricket tournament',
      'fantasy sports auction',
      'sports league management',
      'live sports auction platform',
      'player draft management',
      'sports event management',
      'cricket auction live',
      'online player auction platform',
      'live player auction',

      // Problem-Solving Keywords
      'simplify sports team auction',
      'automate player bidding process',
      'streamline tournament management',
      'efficient team selection system',
    ],
    facebookDomainVerification: 'your-facebook-domain-verification',
  },
  analytics: {
    googleAnalyticsId: 'G-HC86D9N9PX', // Updated GA ID
    facebookPixelId: 'XXXXXXXXXX',
    hotjarId: 'XXXXXXX',
  },
  features: {
    enableBlog: true,
    enableNewsletter: true,
    enableTestimonials: true,
    enableShareButtons: true,
  },
};

export type SiteConfig = typeof siteConfig;
